






























































































































































import Vue from "vue";
import VueCompositionApi, {
  ref,
  onBeforeUpdate,
  onBeforeMount,
  onUpdated,
  onMounted,
  watch,
  computed
} from "@vue/composition-api";
import moment from "moment";

import {
  reportsMessagesHeaders,
  reportsClicksHeaders,
  reportsConversionsHeaders,
  reportsLiveStreamHeaders,
  conversionHeaders,
  dateRanges
} from "../../helpers/consts";

import MessageRow from "../../components/rows/MessageRow.vue";
import ClickRow from "../../components/rows/ClickRow.vue";
import ConversionRow from "../../components/rows/ConversionRow.vue";
import StreamRow from "../../components/rows/StreamRow.vue";

export default Vue.extend({
  name: "Reports",
  components: {
    MessageRow,
    ClickRow,
    ConversionRow,
    StreamRow
  },
  setup(props, context: any): any {
    const title = ref("");
    const headers = ref([]);
    const items = ref([]);
    const route = computed(() => context.root.$route);
    const loading = computed(() => context.root.$store.state.loading);
    const selectedGrouping = ref("DIMENSION_PRODUCT_VARIANT");
    const selectedDateRange = ref(604800);
    let action = "";
    let state = "";
    let mutation = "";
    let endpoint = "";

    function getDateRange() {
      const currentTimestamp = Math.round(+new Date());
      const previousTimeStamp =
        currentTimestamp - selectedDateRange.value * 1000;
      return {
        startDate: {
          year: moment(previousTimeStamp).year(),
          month: moment(previousTimeStamp).month() + 1,
          day: moment(previousTimeStamp).date()
        },
        endDate: {
          year: moment(currentTimestamp).year(),
          month: moment(currentTimestamp).month() + 1,
          day: moment(currentTimestamp).date()
        }
      };
    }

    function getReport(reset) {
      if (reset) {
        context.root.$store.dispatch("shop/resetReports");
      }

      const nextPageToken = context.root.$store.state.shop[state].nextPageToken;
      const dateRange = getDateRange();

      let payload = {};
      if (
        context.root.$route.name !== "ReportConversions" &&
        context.root.$route.name.includes("Report")
      ) {
        if (nextPageToken) {
          payload = { nextPageToken, dateRange, endpoint, mutation };
        } else {
          payload = { dateRange, endpoint, mutation };
        }
      } else if (context.root.$route.name === "ReportConversions") {
        const dimension = selectedGrouping.value;
        if (nextPageToken) {
          payload = { nextPageToken, dateRange, endpoint, mutation, dimension };
        } else {
          payload = { dateRange, dimension, endpoint, mutation };
        }
      } else if (context.root.$route.name === "CampaignsConversions") {
        const dimension = selectedGrouping.value;
        if (nextPageToken) {
          payload = { nextPageToken, endpoint, mutation, dimension };
        } else {
          payload = { dimension, endpoint, mutation };
        }
      } else {
        if (nextPageToken) {
          payload = { nextPageToken, endpoint, mutation };
        } else {
          payload = { endpoint, mutation };
        }
      }
      context.root.$store.dispatch(action, { ...payload });
    }

    function pageUpdate() {
      const nextPageToken = context.root.$store.state.shop[state].nextPageToken;
      if (nextPageToken) {
        getReport(false);
      }
    }

    const reportsMessages = computed(
      () => context.root.$store.state.shop.reportsMessages.data
    );
    const reportsClicks = computed(
      () => context.root.$store.state.shop.reportsClicks.data
    );
    const reportsConversions = computed(
      () => context.root.$store.state.shop.reportsConversion.data
    );
    const reportsStream = computed(
      () => context.root.$store.state.shop.reportsStream.data
    );
    const campaignsMessages = computed(
      () => context.root.$store.state.shop.campaignsMessages.data
    );
    const campaignsClicks = computed(
      () => context.root.$store.state.shop.campaignsClicks.data
    );
    const campaignsConversions = computed(
      () => context.root.$store.state.shop.campaignsConversions.data
    );

    function init() {
      const routeName = route.value.name;
      switch (routeName) {
        case "ReportMessages":
          context.root.$mixpanel.track("Page Load", {
            Page: "Report Messages"
          });
          headers.value = reportsMessagesHeaders;
          action = "shop/getReport";
          state = "reportsMessages";
          mutation = "setReportMessages";
          endpoint = "messages";
          title.value = "Reports / Messages";
          break;
        case "ReportClicks":
          context.root.$mixpanel.track("Page Load", { Page: "Report Clicks" });
          headers.value = reportsClicksHeaders;
          action = "shop/getReport";
          state = "reportsClicks";
          mutation = "setReportClicks";
          endpoint = "links";
          title.value = "Reports / Clicks";
          break;
        case "ReportConversions":
          context.root.$mixpanel.track("Page Load", {
            Page: "Report Conversions"
          });
          headers.value = reportsConversionsHeaders;
          action = "shop/getReport";
          state = "reportsConversion";
          mutation = "setReportConversions";
          endpoint = "conversions";
          title.value = "Reports / Conversions";
          break;
        case "ReportStream":
          context.root.$mixpanel.track("Page Load", { Page: "Report Stream" });
          headers.value = reportsLiveStreamHeaders;
          action = "shop/getReport";
          state = "reportsStream";
          mutation = "setReportStream";
          endpoint = "stream";
          title.value = "Reports / Stream";
          break;
        case "CampaignsMessages":
          context.root.$mixpanel.track("Page Load", {
            Page: "Campaign Messages"
          });
          headers.value = reportsMessagesHeaders;
          action = "shop/getReport";
          state = "campaignsMessages";
          mutation = "setCampaignsMessages";
          endpoint = `campaigns/${route.value.params.campaignId}/recipients`;
          title.value = "Campaign / Messages";
          break;
        case "CampaignsClicks":
          context.root.$mixpanel.track("Page Load", {
            Page: "Campaign Clicks"
          });
          headers.value = reportsClicksHeaders;
          action = "shop/getReport";
          state = "campaignsClicks";
          mutation = "setCampaignsClicks";
          endpoint = `campaigns/${route.value.params.campaignId}/links`;
          title.value = "Campaign / Clicks";
          break;
        case "CampaignsConversions":
          context.root.$mixpanel.track("Page Load", {
            Page: "Campaign Conversions"
          });
          headers.value = reportsConversionsHeaders;
          action = "shop/getReport";
          state = "campaignsConversions";
          mutation = "setCampaignsConversions";
          endpoint = `campaigns/${route.value.params.campaignId}/conversions`;
          title.value = "Campaigns / Conversions";
          break;
        default:
          break;
      }
      getReport(true);
    }

    onBeforeMount(() => {
      init();
    });

    watch(
      () => route.value,
      (first, second) => {
        context.root.$store.dispatch("shop/resetReports");
        init();
      }
    );

    return {
      title,
      loading,
      headers,
      items,
      route,
      selectedDateRange,
      selectedGrouping,
      reportsMessagesHeaders,
      reportsClicksHeaders,
      reportsConversionsHeaders,
      reportsLiveStreamHeaders,
      conversionHeaders,
      dateRanges,
      pageUpdate,
      reportsMessages,
      reportsClicks,
      reportsConversions,
      reportsStream,
      campaignsMessages,
      campaignsClicks,
      campaignsConversions,
      getReport
    };
  }
});
